export type LabelFormatId =
  | "thermal_4x6"
  | "thermal_4x4"
  | "thermal_4x5"
  | "thermal_4x8"
  | "letter"
  | "a4";

export interface LabelFormatOption {
  id: LabelFormatId;
  title: string;
  subtitle: string;
  recommended?: boolean;
}

export const DEFAULT_LABEL_FORMAT: LabelFormatId = "thermal_4x6";

export const LABEL_FORMATS: LabelFormatOption[] = [
  {
    id: "thermal_4x6",
    title: "4 × 6 in — Standard shipping label",
    subtitle: "Recommended · 102 × 152 mm · thermal printers",
    recommended: true,
  },
  {
    id: "thermal_4x4",
    title: "4 × 4 in — Square label",
    subtitle: "102 × 102 mm · compact thermal",
  },
  {
    id: "thermal_4x5",
    title: "4 × 5 in — Compact shipping label",
    subtitle: "102 × 127 mm · thermal printers",
  },
  {
    id: "thermal_4x8",
    title: "4 × 8 in — Extended shipping label",
    subtitle: "102 × 203 mm · thermal printers",
  },
  {
    id: "letter",
    title: "8.5 × 11 in — Full sheet / regular printer",
    subtitle: "216 × 279 mm · Letter paper",
  },
];

const LEGACY_A4: LabelFormatOption = {
  id: "a4",
  title: "A4 (portrait)",
  subtitle: "Legacy size · 210 × 297 mm",
};

const KNOWN_IDS = new Set<LabelFormatId>(LABEL_FORMATS.map((item) => item.id));

export const isLabelFormatId = (value: unknown): value is LabelFormatId =>
  typeof value === "string" &&
  (KNOWN_IDS.has(value as LabelFormatId) || value === "a4");

export const mergeLabelFormats = (
  incoming?: LabelFormatOption[] | null,
  selected?: LabelFormatId | null
): LabelFormatOption[] => {
  const incomingById = new Map(
    (incoming || [])
      .filter((item) => item && isLabelFormatId(item.id))
      .map((item) => [item.id, item])
  );
  const list = LABEL_FORMATS.map((item) => {
    const extra = incomingById.get(item.id);
    return extra
      ? {
          ...item,
          recommended: extra.recommended ?? item.recommended,
        }
      : item;
  });
  if (selected === "a4") {
    list.push(incomingById.get("a4") || LEGACY_A4);
  }
  return list;
};
